import { Box, Grid } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useGetCodTransactionsStatsByAdminQuery, useGetCodTransactionsStatsQuery } from "src/_api/mapitShipInvoice"
import { StatCard } from "../../../../../modules/Admin/MapitShipInvoices/components"
import { AccountBalance, AccountBalanceWallet, Payments } from "@mui/icons-material"
import { get } from "lodash"
import { useSelector } from "react-redux"
import { ROLES } from "src/constants"
import UpcomingInvoicesDetailsDialog from "./UpcomingInvoicesDetailsDialog"
import { useMemo } from "react"
import moment from "moment"

export default function CodStatsCards({
    statsCard = [
        "settledTotalAmount",
    ]
}) {
    const { t } = useTranslation()
    const { profile } = useSelector((state) => state.entities.profile)

    const getNextTransferDate = () => {
        const today = moment()
        const currentDate = today.date()
        
        if (currentDate >= 15) {
            // If we're past the 15th, return the first day of next month
            return today.clone().add(1, 'month').startOf('month').format('DD/MM/YY')
        } else {
            // If we're before the 15th, return the 15th of current month
            return today.clone().date(15).format('DD/MM/YY')
        }
    }

    const STATUS_CARDS = useMemo(() => {
        return [
            { key: "upcomingTotalAmount", color: "primary.main", icon: <Payments sx={{ fontSize: "38px" }} />, cardInfo: t("expectedTransfer", { date: getNextTransferDate() }), cardActions: <UpcomingInvoicesDetailsDialog /> },
            { key: "currentTotalAmount", color: "primary.main", icon: <AccountBalanceWallet sx={{ fontSize: "38px" }} /> },
            { key: "settledTotalAmount", color: "primary.main", icon: <AccountBalance sx={{ fontSize: "38px" }} /> }
        ]
    }, [moment])

    const selectedStatusCards = STATUS_CARDS.filter(card => statsCard.includes(card.key))

    const {
        data: stats,
        isLoading: statsLoading,
        isFetching: statsFetching,
    } = useGetCodTransactionsStatsQuery({}, { skip: !!profile?.role ?  !(profile?.role === "MERCHANT") : true })

    const {
        data: statsAdmin,
        isLoading: statsAdminLoading,
        isFetching: statsAdminFetching,
    } = useGetCodTransactionsStatsByAdminQuery({}, { skip: profile?.role === ROLES.admin ? false : true })

    const data = profile?.role === ROLES.admin ? statsAdmin : stats
    const isLoading = statsAdminLoading || statsLoading
    const isFetching = statsAdminFetching || statsFetching

    return (
        <Box sx={{ my: 2 }}>
            <Grid container spacing={3} justifyContent="stretch">
                {
                    selectedStatusCards?.map((card) => (
                        <Grid item lg={4} md={12} sm={12} xs={12} key={card.key}>
                            <StatCard
                                loading={isLoading || isFetching}
                                color={card.color}
                                icon={card.icon}
                                title={t(`codStatistics.${card.key}`)}
                                value={get(data, card.key)}
                                cardActions={card?.cardActions}
                                cardInfo={card?.cardInfo}
                                currency={t("SAR")}
                            />
                        </Grid>
                    ))
                }
            </Grid>
        </Box>
    )
}
